Vue.component("HotspotButton", {
    props: ["hotspot", "index", "settings", "resetHotspot", "activeHotspot"],
    template: `
        <div class="HotspotButton" @click="reset" :class="setHotspotLockedClass" :style="[{left: hotspot.x + 'px', top: hotspot.y + 'px'}, getHotspotColor]">
            <div class="label">{{hotspot.title}} </div>
        </div>
    `,
    data() {
        return {
            isHotspotLocked: false,
            get completedHotspots() {
                return app.localStore.get("hotspots-completed").completed || []
            } 
        }
    },
    mounted() {
        this.isHotspotLockedCheck();
        window.addEventListener('hotspotcompleted', (event) => {
            this.isHotspotLockedCheck();
        }, false);
    },
    destroyed() {
        window.removeEventListener('hotspotcompleted', (event) => {
            this.isHotspotLockedCheck();
        }, false);
    },
    methods: {
        goto(hotspot) {
            // Call goto() in PageScene
            this.$emit("goto", hotspot)
        },
        isHotspotLockedCheck() {
            if (!this.hotspot.data.neededForUnlock)
                return

            let isSaved = false;
            isSaved = this.completedHotspots.find(a => {
                if (a == this.hotspot.data.neededForUnlock) {
                    return true;
                }
            })

            this.isHotspotLocked = isSaved === undefined ? true : false
        },
        reset() {
            localStorage.removeItem('tavlemoder');
            location.reload();
        }
    },
    computed: {
        getHotspotColor() {
            if (this.hotspot.data.hotspotColor !== "")
                return {
                    background: this.hotspot.data.hotspotColor
                }
        },
        setHotspotLockedClass() {
            return {
                'hotspot--locked': this.isHotspotLocked
            }
        }
    }
});